import { render, staticRenderFns } from "./TeamInbox.vue?vue&type=template&id=cb091194&"
import script from "./TeamInbox.vue?vue&type=script&lang=js&"
export * from "./TeamInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports